import React from "react";
import logger from "logger";

export default function(props) {
  return (
    <div style={{ color: "red", padding: "10px", align: "left" }}>
      DISCLAIMER and TOS* :
      <br />
      We reserve the right to modify, restrict or terminate our service or
      access in part or whole at anytime without warning.
      <br />
      By using our services, you agree to the TOS.
      <br />
      For queries or any other issues or clarifications, please contact lineid:
      batmanjla
    </div>
  );
}
